import React, { Component } from "react";

export default class Form extends Component {
  constructor(props) {
    super(props);
    this.state = {
      displayErrors: false,
      displayMessage: false,

      fetchURL: "https://www.skodalaagri.ee/sko/wp-content/themes/skodalaagri2017/rent/php/send_message.php",
      //"https://www.skodalaagri.ee/sko/wp-content/themes/skodalaagri2017/react_form/send_message.php",
      /* fetchURL:
              "http://skoda_laagri.localhost/wordpress/wp-content/themes/skodalaagri2017/react_form/send_message.php",
            */
      isZoomed: false,
      success: false,
    };
    //this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  onSuccess = () => {
    this.clearForm();
    setTimeout(() => {
      this.setState((prevState) => ({
        success: false,
      }));
    }, 4000);
  };

  clearForm = () => {
    this.form.reset();
    this.props.wasFormCleared();
  };

  handleSubmit(event) {
    const { car } = this.props;
    event.preventDefault();
    if (!event.target.checkValidity()) {
      // form is invalid! so we do nothing

      this.setState({ displayErrors: true });
      return;
    }

    const data = new FormData(event.target),
      { fetchURL } = this.state;
    //this.props.type ? data.append("type", this.props.type) : "";
    data.append("url", window.location.href);
    let carName = car.make.label + " " + car.model + " " + car.model_name;
    data.append("model", carName);
    this.setState({ displayErrors: false });
    fetch(`${fetchURL}`, {
      method: "POST",
      body: data,
    })
      .then((response) => response.json())
      .then((response) => {
        this.setState({
          success: response.message === "success",
        });
        if (response.message === "success") {
          this.onSuccess();
          window.gtag("event", "request", {
            event_category: this.props.type,
            event_label: "success",
          });
        }
      })
      .catch((error) => console.error("Error:", error));
    this.setState({ displayMessage: true });
  }

  render() {
    const { displayErrors, success } = this.state;
    return (
      <form
        onSubmit={this.handleSubmit}
        noValidate
        className={`${this.props.className} ${
          displayErrors ? "displayErrors" : ""
        }`}
        ref={(form) => (this.form = form)}
      >
        {!displayErrors && success ? (
          <div className="message">
            Täname, teie päring on saadetud. <br />
            Võtame Teiega ühendust.
          </div>
        ) : (
          ""
        )}
        {this.props.children}
      </form>
    );
  }
}
